module.exports = __webpack_public_path__ + "img/jingdong.bb1b8096.jpg";